import { BrandPanel } from "../../design-system";
import { Orb } from "../../components/layout/Orb";

export interface WizardStepMeta {
  key: string;
  title: string;
  desc: string;
}

/* The onboarding wizard's left panel. Shares the single BrandPanel with the
 * auth screens (the Figma guideline's white hero on the leaf photograph,
 * OPSS-22), with the animated Orb above the hero. The step progress lives in
 * the right panel's stepper (see WizardStepper). */
export function WelcomeTimeline() {
  return <BrandPanel visual={<Orb size={56} color="#FFFFFF" />} />;
}
